<template>
  <div class="news"> 
    <el-tabs v-model="activeName" type="card">
        <el-tab-pane :label="'公告 [共'+ data1Len+'筆]'" name="first">
          <div class="dataTables_scroll">
            <div class="dataTables_scrollHead" style="overflow: hidden; position: relative; border: 0px; width: 100%;">
              <table style="margin:0.5em; width:100%;" cellspacing="0" >
                <thead>
                  <tr>
                    <th style="width:10em; padding:0.5em;">發布日期</th>
                    <th style="padding:0.5em;">公告內容</th>
                  </tr>
                </thead>
              </table>
            </div>
            <div class="dataTables_scrollBody" style="position: relative; overflow: auto; max-height: 370px; width: 100%; border-bottom: 1px solid #111; border-top: 1px solid #111;">
              <table id="example" class="compact cell-border row-border dataTable no-footer" style="border-bottom:none; width: 100%;">
                    <tbody>
                      <tr v-for="(item,index) in filterShoppingList1" :key="index" :index="'0'+index" :name="'N1'+index"
                          v-show="data1Len>0">
                        <td class="td-style" style="width:8em;">
                          {{item.startDate | dateFormat}}<img src='@/assets/images/gif-new.gif' v-show="checkNewsTime(item.startDate)">
                        </td>
                        <td class="td-style news-style" style="display: block;">
                          <span v-html="item.content" v-if="1==item.newsType"></span>
                          <span v-if="0==item.newsType">{{item.content}}</span>
                          <a v-for="(f,index1) in item.info" :key="index1" :index="'0'+index1" :name="'F1'+index1"
                            :href="'./WebApi/Tools/GetAttach/'+f.rowId" target="_blank"
                            :title="f.name">
                              <img v-if="f.img != null" :src="f.img" style="width:1.5em; height:1.5em;" alt="">
                              <span  v-if="f.img == null">
                                <img v-if="f.type === 'application/msword'" src="@/assets/images/word.gif" style="width:1.5em; height:1.5em;">
                                <img v-else-if="f.type === 'image/jpeg'" src="@/assets/images/image.gif" style="width:1.5em; height:1.5em;">
                                <img v-else-if="f.type === 'application/pdf'" src="@/assets/images/pdf.gif" style="width:1.5em; height:1.5em;">
                                <img v-else src="@/assets/images/attachment.png" style="width:1.5em; height:1.5em;">
                              </span>
                          </a>
                        </td>
                      </tr>
                      <tr v-show="0 == data1Len">
                        <td colspan="2" style="line-height:2.25em;">目前無公告~</td>
                      </tr>
                  </tbody>
              </table>
            </div>
          </div>
        </el-tab-pane>
        <!--<el-tab-pane :label="'附表下載 [共'+ data2Len+'筆]'" name="second">
          <div class="dataTables_scroll">
            <div class="dataTables_scrollHead" style="overflow: hidden; position: relative; border: 0px; width: 100%;">
              <table style="margin: 0.5em;width:100%;" cellspacing="0" >
                <thead>
                  <tr>
                    <th style="width:10em; padding:0.5em;">發布日期</th>
                    <th style="padding:0.5em;text-align:left;">檔案內容</th>
                    <th style="width:16em; padding:0.5em; text-align:left;">下載</th>
                  </tr>
                </thead>
              </table>
            </div>
            <div class="dataTables_scrollBody" style="position: relative; overflow: auto; max-height: 400px; width: 100%; border-bottom: 1px solid #111; border-top: 1px solid #111;">
              <table id="example" class="compact cell-border row-border dataTable no-footer" style="border-bottom:none; width: 100%;">
                <tbody>
                  <tr v-for="(item, index) in filterShoppingList2" :key="index" :index="'0'+index" :name="'N2'+index"
                      v-show="data2Len>0">
                    <td class="td-style" style="width:10em;">
                      {{item.startDate | dateFormat}}&nbsp;<img v-if="true" src="@/assets/images/gif-new.gif" />
                    </td>
                    <td class="td-style news-style" style="display: block;">
                      {{item.content}}
                    </td>
                    <td class="td-style" style="width:16em;">
                      <a v-for="(f, index2) in item.info" :key="index2" :index="'0'+index2" :name="'F2'+index2"
                        :href="'./WebApi/Tools/GetAttach/'+f.rowId" target="_blank"
                        :title="f.name">
                        (<img src="@/assets/images/disk.png" /> {{f.ext}})
                      </a>
                    </td>
                </tr>
                <tr v-show="0 == data2Len">
                  <td colspan="3" style="line-height:2.25em;">目前無附表下載~</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </el-tab-pane>-->
    </el-tabs> 
  </div>
</template>

<script>
export default {
  name: 'News',
  data () {
    return {
      activeName: 'first',
      docRecordList: null,
      data1Len: 0,
      data2Len: 0
    }
  },
  computed: {
    sysId () {
      return this.$store.getters.getSysId
    },
    setting () {
      return this.$store.getters.getSetting
    },
    enroll () {
      return this.$store.getters.getEnrollInfo
    },
    user () {
      return this.$store.getters.getUser
    },
    filterShoppingList1: function () { 
      if (null != this.docRecordList) {
        var shoppingList = this.docRecordList;
          return shoppingList.filter(function (item) {
            return item.newsType<2
        });
      }
      return [];
    },
    filterShoppingList2: function () { 
      if (null != this.docRecordList) {
        var shoppingList = this.docRecordList;
          return shoppingList.filter(function (item) {
            return item.newsType==2
        });
      }
      return [];
    }
  },
  methods: {
    checkNewsTime: function (startTime) {
      var date1 = new Date(startTime);
      var date2 = new Date();
      var timeDiff = Math.abs(date2.getTime() - date1.getTime());
      var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));

      return (isNaN(diffDays) || (diffDays > 7) ? false : true);
    }
  },
  filters: {  
    dateFormat:function(input) {   
       var d = new Date(input);
       var year = d.getFullYear();
       var month = d.getMonth() + 1;
       var day = d.getDate() <10 ? '0' + d.getDate() : '' + d.getDate(); 
       return  year+ '/' + month + '/' + day ; 
    }  
  },
  created () {
    var vm = this;
    var curDate = new Date();
    var url = './WebApi/Apply/GetSystemNews/'
          .concat(this.sysId).concat('/')
          .concat([curDate.getFullYear(),
             curDate.getMonth() + 1,
             curDate.getDate()].join('-')).concat('/')
          .concat(this.user.status)
          .concat('/0');
    this.$http
        .get(url)
        .then(function(response) {
          vm.docRecordList = response.data;
          vm.data1Len = 0;
          vm.data2Len = 0;
          if (null != vm.docRecordList) {
            for (var i=0; i < vm.docRecordList.length; i++) {
              if (vm.docRecordList[i].newsType<2) {
                vm.data1Len +=1;
              } else {
                vm.data2Len +=1;
              }
            }
          }
        })
        .catch(function (error) {
          vm.$message.error('對不起,網路連線失敗');
        }) 
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
p
{
  margin-top:0; 
  margin-bottom:0;
}
.td-style {
  padding:0.25em 0.5em; 
  vertical-align: top; 
  text-align: left;
}
.news-style {
    border-bottom-color: #eef7f2;
    border-bottom-style: ridge;
    border-bottom-width: thin;
}
</style>



// WEBPACK FOOTER //
// src/components/NewsView.vue